import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5090e26c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "follow-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src"]

import { ref } from "vue";
import Modal from "@/components/PcComponents/Modal";
import { getGameCommunity, buriedPoint } from "@/api/indexPC";
import { GlobalState } from "@/pages/index/store";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  async setup(__props) {

let __temp: any, __restore: any

const store = useStore<GlobalState>();
let isShow = ref(false);
let qrcode = ref("");

/**
 *
 * @param obj PC弹出方式[1-弹出二维码,2-显示QQ群,3-跳转链接]
 */
function gotoCommunity(obj: any) {
  // 埋点
  buriedPoint(obj.name, 1);
  if (obj.way === 1) {
    // 弹出二维码
    isShow.value = true;
    qrcode.value = obj?.code;
  }
  if (obj.way === 3) {
    // 跳转链接
    window.open(obj.url);
  }
}

let result = (
  ([__temp,__restore] = _withAsyncContext(() => getGameCommunity())),
  __temp = await __temp,
  __restore(),
  __temp
);
let gameCommunityList = ref<any[]>([]);
gameCommunityList.value = result.data;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "gaming-community",
    id: "gaming_community",
    style: _normalizeStyle({
      backgroundImage: 'url(' + _unref(store)?.state?.imageObj?.backg?.bbs?.pc + ')',
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(store)?.state?.imageObj?.title?.bbs?.pc,
        alt: "游戏社区"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      class: "follow",
      style: _normalizeStyle({
        backgroundImage: 'url(' + _unref(store)?.state?.imageObj?.border?.bbs?.pc + ')',
      })
    }, _toDisplayString(_unref(store)?.state?.prosperityObj?.bbs_titile), 5),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameCommunityList), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.id,
          onClick: ($event: any) => (
          gotoCommunity({
            way: item?.way,
            url: item?.url,
            code: item?.code,
            qq: item?.qq,
            name: item?.name,
          })
        )
        }, [
          _createElementVNode("img", {
            src: item?.img,
            alt: item?.name
          }, null, 8, _hoisted_5)
        ], 8, _hoisted_4))
      }), 128))
    ]),
    _createVNode(_unref(Modal), {
      show: _unref(isShow),
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_isRef(isShow) //@ts-ignore
 ? isShow.value = false : isShow = false))
    }, {
      qrcode: _withCtx(() => [
        _createElementVNode("img", { src: _unref(qrcode) }, null, 8, _hoisted_6)
      ]),
      _: 1
    }, 8, ["show"])
  ], 4))
}
}

})